import styled, { css } from 'styled-components';
import { colors } from 'global/colors';

export const ContentContainer = styled.div`
  width: 100%;
  ${(props) =>
    props.isReportPage &&
    css`
      padding: 0 20px 20px 20px;
    `}
`;

export const TabList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;

  @media print {
    display: none;
  }
`;

export const TabItem = styled.div`
  user-select: none;
  padding: 0.5rem 0.8rem;
  margin-right: 5px;
  background-color: ${colors.white};
  position: relative;
  color: #919396 !important;
  border: 1px ${colors.borderGray};
  border-style: solid solid none solid;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  cursor: pointer;
  text-align: center;
  ${(props) =>
    props.active &&
    css`
      z-index: 1;
      color: ${colors.darkBlue} !important;
      background-color: ${colors.white};
      font-weight: 600;
      // Cover the border from TabList and off-set the height difference
      margin-top: -1px;
      top: 1px;
      border-bottom: 1px solid ${colors.white};
    `}
`;

export const ActiveArea = styled.div`
  border: 1px solid ${colors.borderGray};
  ${(props) =>
    props.isReportPage &&
    css`
      box-shadow: 0 5px 15px rgb(0 0 0 / 30%);
    `}
`;
